import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
    FormField,
    FormInput,
    FormLabel,
} from 'yurstrap';

import {
    getCookiesGroupSelector,
    setCookieGroup,
    isCookieGroupAcceptedSelector,
    getCookiesIdsByGroupSelector,
} from '../../reduxModules/ConsentManagementPlatform';

import { getLanguageSelector } from '../../../commons/selectors/LanguageSelector';

const propTypes = {
    AppActions: PropTypes.shape({
        setCookieGroup: PropTypes.func.isRequired,
    }).isRequired,
    cookieGroup: PropTypes.object.isRequired,
    cookiesIds: PropTypes.array.isRequired,
    isCookieGroupAccepted: PropTypes.bool.isRequired,
    sessionLanguage: PropTypes.string.isRequired,
};

class WidgetCookiesCheckbox extends Component {

    constructor(props) {
        super(props);
        this.checkCookieGroup = this.checkCookieGroup.bind(this);
    }

    checkCookieGroup() {
        const {
            AppActions,
            cookiesIds,
            isCookieGroupAccepted,
        } = this.props;
        AppActions.setCookieGroup(cookiesIds, !isCookieGroupAccepted);
    }

    render() {
        const {
            cookieGroup,
            isCookieGroupAccepted,
            sessionLanguage,
        } = this.props;
        // cookieGroupName has to be rendered depending on the language, based on the "name"
        // property in frenchand on the "id" one in english.
        // In english, since the id is in capital letters, we have to modify the string
        // to obtain the same format as in french.
        const cookieGroupName = sessionLanguage === 'fr'
            ? cookieGroup.name
            : cookieGroup.id.charAt(0) + cookieGroup.id.slice(1).toLowerCase();
        return (
            <FormField
                type="checkbox"
                className="u-col-auto px-3 pl--m-0 py--m-3"
            >
                <FormInput
                    id={cookieGroup.id}
                    type="checkbox"
                    checked={isCookieGroupAccepted}
                    onChange={this.checkCookieGroup}
                />
                <FormLabel
                    className="u-font-size--2 mb-0"
                    htmlFor={cookieGroup.id}
                >
                    {cookieGroupName}
                </FormLabel>
            </FormField>
        );
    }

}

WidgetCookiesCheckbox.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
    return {
        cookieGroup: getCookiesGroupSelector(state, ownProps.cookieGroupId),
        isCookieGroupAccepted: isCookieGroupAcceptedSelector(state, ownProps.cookieGroupId),
        cookiesIds: getCookiesIdsByGroupSelector(state, ownProps.cookieGroupId),
        sessionLanguage: getLanguageSelector(),
    };
}
function mapDispatchToProps(dispatch) {
    return {
        AppActions: bindActionCreators({
            setCookieGroup,
        }, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(WidgetCookiesCheckbox);
